import React, { useMemo } from "react"
import { AgGridReact, AgGridReactProps, AgReactUiProps } from "@ag-grid-community/react";
import { GridOptions } from "@ag-grid-community/all-modules";
import { sumArray } from "common/decimal";
import { MenuModule } from "@ag-grid-enterprise/menu";

const defaultGridOptions: GridOptions = {
    suppressContextMenu: true,
    enableCellTextSelection: true,
    suppressMovableColumns: true,
    rowHeight: 24,
    headerHeight: 24,
    aggFuncs: {
        "npSum": params => sumArray(params.values),
        /**
         * sum each index of an array of number tuples
         * eg [[1,2], [3,4], [5,6]] => [9,12] ([1+3+5, 2+4+6])
         */
        "npSumTuples": params => (params.values as number[][])
            .reduce<number[][]>((acc, cur) => {
                for (const [index, value] of cur.entries()) {
                    if (acc[index] == null) acc[index] = [];
                    if (value != null) acc[index].push(value)
                }
                return acc;
            }, [])
            .map(sumArray),
    },
    domLayout: "autoHeight",
    tooltipShowDelay: 250,
};

interface StandardGridProps extends AgGridReactProps, AgReactUiProps {
    ref?: React.ForwardedRef<AgGridReact | undefined>;
    'data-testid'?: string;
}

const StandardGrid: React.FC<StandardGridProps> = React.forwardRef<AgGridReact | undefined, StandardGridProps>((props, ref) => {
    const modules = useMemo(() => [MenuModule, ...(props.modules ?? [])], [props.modules]);

    return <div className="ag-theme-alpine full-width" data-testid={props["data-testid"]}>
        <AgGridReact
            modules={modules}
            ref={ref}
            {...defaultGridOptions}
            {...props}>
            {props.children}
        </AgGridReact>
    </div>
});

export default StandardGrid;